var exports = {
  "vK": "ChannelFollowModal.module__banner___MnlrUj",
  "Wp": "ChannelFollowModal.module__patternImage___MnlrUj",
  "JE": "ChannelFollowModal.module__bannerRow___MnlrUj",
  "QE": "ChannelFollowModal.module__sourceGuildIcon___MnlrUj",
  "AQ": "ChannelFollowModal.module__sourceChip___MnlrUj",
  "fS": "ChannelFollowModal.module__sourceChipIcon___MnlrUj",
  "jl": "ChannelFollowModal.module__sourceChipName___MnlrUj",
  "Qs": "ChannelFollowModal.module__content___MnlrUj",
  "Lv": "ChannelFollowModal.module__intro___MnlrUj",
  "DD": "ChannelFollowModal.module__title___MnlrUj",
  "h_": "ChannelFollowModal.module__description___MnlrUj",
  "aK": "ChannelFollowModal.module__hint___MnlrUj",
  "p$": "ChannelFollowModal.module__emptyState___MnlrUj",
  "By": "ChannelFollowModal.module__guildOption___MnlrUj",
  "XN": "ChannelFollowModal.module__guildAvatar___MnlrUj",
  "oM": "ChannelFollowModal.module__guildAvatarPlaceholder___MnlrUj",
  "ed": "ChannelFollowModal.module__optionLabel___MnlrUj",
  "TN": "ChannelFollowModal.module__channelOption___MnlrUj",
  "p": "ChannelFollowModal.module__channelIcon___MnlrUj",
  "yb": "ChannelFollowModal.module__categoryName___MnlrUj",
};

module.exports = exports;
